import { AccountingSubNav } from '../components/AccountingSubNav';
import { Gstr3bReportComponent } from '@/features/accounts/components/reports/Gstr3bReportComponent';

export function AccountingGstr3Page() {
  return (
    <div>
      <AccountingSubNav />
      <div className=" pb-16">
        <Gstr3bReportComponent />
      </div>
    </div>
  );
}
